import { Link, useLocation } from "react-router-dom";
import moment from 'moment-timezone'; // For timezone handling
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import RescheduleModal from "../Modal/RescheduleModal";

export default function CourseTableRow({ data: booking }) {
  const { t } = useTranslation();
  const [rescheduling, setRescheduling] = useState(false);
  const [updated, setUpdated] = useState(null);
  // this row is used by several lists, so it shows a new time itself rather than asking each to reload
  const data = updated?.id === booking?.id ? { ...booking, ...updated } : booking;
  const [timeRemaining, setTimeRemaining] = useState('');
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith("/app");

  useEffect(() => {
    if (!data?.start_time) {
      setTimeRemaining('—');
      return;
    }
    const courseStartTimeUtc = moment.tz(data?.start_time, 'UTC');
    const interval = setInterval(() => {
      const now = moment(); // Current local time
      const diff = moment.duration(courseStartTimeUtc.diff(now)); // Difference between now and course start time

      if (diff.asSeconds() <= 0) {
        clearInterval(interval);
        setTimeRemaining('00:00:00');
      } else {
        const hours = String(Math.floor(diff.asHours())).padStart(2, '0');
        const minutes = String(diff.minutes()).padStart(2, '0');
        const seconds = String(diff.seconds()).padStart(2, '0');
        setTimeRemaining(`${hours}:${minutes}:${seconds}`);
      }
    }, 1000);

    return () => clearInterval(interval); // Clean up on component unmount
  }, [data?.start_time]);
  return (
    <>
      <tr className="align-middle">
        <td data-label={t("courseTableRow.type")}>{data?.course?.course_type == 'recorded' ? t("courseTableRow.recorded") : t("courseTableRow.live")}</td>
        <td data-label={t("courseTableRow.student")}>{data?.student?.name}</td>
        <td data-label={t("courseTableRow.course")}>
          <div className="table-course-detail">
            <Link to={isAppRoute?`/app/course/${data?.course?.slug}`:`/course/${data?.course?.slug}`} className="course-table-img text-info">
              {/* <span><img src={data?.course?.cover_image} alt={data?.course?.title} /></span> */}
              {data?.course?.title}
            </Link>
          </div>
        </td>
        <td data-label={t("courseTableRow.lesson")}>{data?.lesson?.title}</td>
        <td data-label={t("courseTableRow.start_time")}>
          {data?.teacher_local_start_time}
          {data?.rescheduled_at &&
            <small className="d-block text-muted" title={data?.reschedule_reason}>
              <i className="fa-light fa-calendar-clock me-1" />{t("courseTableRow.rescheduled")}
            </small>
          }
        </td>
        <td className="fw-bold" data-label={t("courseTableRow.remaining")}>

          {data?.course?.course_type == 'recorded' ? '' : timeRemaining}

        </td>
       
        <td className="td-actions">
          <div className="table-row-actions">
            {data?.course?.course_type != 'recorded' && data?.room_no ?
              <Link to={`/room/${data?.course?.slug}/${data?.room_no}`} className="row-action-btn primary" title={t("courseTableRow.start_live_class")}>
                <i className="fa-light fa-video" />{t("courseTableRow.start")}
              </Link>
              : ''
            }
            {data?.can_reschedule &&
              <button type="button" className="row-action-btn" title={t("courseTableRow.reschedule")} onClick={() => setRescheduling(true)}>
                <i className="fa-light fa-calendar-clock" />{t("courseTableRow.reschedule")}
              </button>
            }
            <Link to={isAppRoute?`/app/dashboard/enrollment-details/${data?.id}`:`/dashboard/enrollment-details/${data?.id}`} className="row-action-btn" title={t("courseTableRow.view_enrollment_details")}>
              <i className="fa-light fa-eye" />{t("courseTableRow.details")}
            </Link>
          </div>
          <RescheduleModal show={rescheduling} onHide={() => setRescheduling(false)} session={data} onRescheduled={setUpdated} />
        </td>
      </tr>
    </>
  )
}